import script from "./SelectQuiz.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectQuiz.vue?vue&type=script&setup=true&lang=js"

import "./SelectQuiz.vue?vue&type=style&index=0&id=1ceeec12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ceeec12"]])

export default __exports__